import { createAction, props } from "@ngrx/store";
import { ErrorModel } from "@spartacus/core";

export const fetchCarouselImagesAction = createAction(
    '[Home Page] fetch Carousel Images',
    props<{ bannersImages:string[]}>()
);

export const fetchCarouselImagesActionSuccess = createAction(
    '[Home Page] fetch Carousel Images Success',
    props<{ imageList: string[] }>()
);

export const fetchCarouselImagesActionFail = createAction(
    '[Home Page] fetch Carousel Images Fail',
    props<{ payload: ErrorModel }>()
);

export const updateCarouselImages = createAction(
    '[Home Page] update carousel image index',
    props<{ activeIndex: number }>() 
);
